import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toHoursAndMinutes',
    standalone: false
})
export class HoursAndMinutesPipe implements PipeTransform {

  transform(value: number | undefined): string {
    if (value == null) {
      return '';
    }

    const hours = Math.floor(value);
    const minutes = Math.round((value - hours) * 60);
    return `${hours}h ${minutes}m`;
  }
}